import endpoints from '../endpoints.ts';
import { fetch } from './helpers.ts';

export interface HashTable {
  [key: string]: number[];
}

export interface OrderHashData {
  millisecondsSinceEpoch: number;
  sgtinHashTable: HashTable;
  sgtinHashTableSalted: HashTable;
  sgtinHashTablePeppered: HashTable;
  containerPrefixes: string[];
}

const orderHashMicroservice = {
  read: {
    hashTable: {
      by: {
        userId: async (milliseconds: number): Promise<OrderHashData | null> => {
          const url =
            endpoints.orderHashMicroservice.read.hashTable.by.userId();
          const data = await fetch<OrderHashData>(url, 'GET', { milliseconds });
          return data;
        },
      },
    },
  },
};

export default orderHashMicroservice;
